import { useCallback } from 'react'
import type { GradeResult } from '../lib/grade'
import type { InputMode, SessionRecord } from '../types'
import { toneTally } from '../lib/analysis'
import { uid } from '../lib/id'
import { useStore } from './store'

interface RecordArgs {
  islandId: string
  mode: SessionRecord['mode']
  score: number
  seconds: number
  inputMode?: InputMode
  /** Supplied by typing drills so the tone profile can accumulate. */
  result?: GradeResult
}

/**
 * Writes one practice result to history and moves the island's schedule.
 *
 * Listening does not advance the schedule: recognising a sentence is not the
 * same as producing it, and letting playback push the review date out would
 * hollow out the whole system.
 */
export function useRecorder() {
  const { dispatch } = useStore()

  return useCallback(
    ({ islandId, mode, score, seconds, inputMode, result }: RecordArgs) => {
      const record: SessionRecord = {
        id: uid('ses'),
        at: Date.now(),
        islandId,
        mode,
        score: Math.round(score),
        seconds: Math.round(seconds),
        ...(inputMode ? { inputMode } : {}),
        ...(result && inputMode === 'pinyin' ? { tones: toneTally(result.tokens) } : {}),
      }
      dispatch({ type: 'recordSession', record, advanceSrs: mode !== 'listen' })
    },
    [dispatch],
  )
}
